import * as Radix from '@radix-ui/react-label';
import styled, { css } from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { formLabel } from '../../../theme/typography/styles.js';
import { responsiveProperty } from '../../utils/responsiveProperty/responsiveProperty.js';

var labelInvalidStyles = css(["color:", ";"], themeGet('colors.text.danger'));
/** @deprecated - Should be removed once the $labelSize prop is removed. */
var labelFontSize = {
  small: themeGet('fontSize.small'),
  medium: themeGet('fontSize.medium'),
  large: themeGet('fontSize.large')
};
var StyledLabel = styled(Radix.Root).withConfig({
  displayName: "StyledLabel",
  componentId: "sc-16ozbsf-0"
})(["", ";transition:color 0.1s ease-in-out;font-size:", ";", ";&:has(+ * :disabled){color:", ";}&:has(+ * :focus-visible){color:", ";}", ";"], formLabel, function (props) {
  return labelFontSize[props.$labelSize || 'small'];
}, function (props) {
  return props.$fontSize && responsiveProperty('fontSize', props.$fontSize);
}, themeGet('colors.disabled.200'), function (props) {
  return !props.$invalid && themeGet('colors.primary.1000');
}, function (props) {
  return props.$invalid && labelInvalidStyles;
});

export { StyledLabel };
